<template>
  <div :class="{'hideleft':hide === true}" class="page">
    <div class="crumb-container">
      <ol class="breadcrumb">
        <li>
          <a href="javascript:;" class="crumb-home z-font-size-14">产品</a>
        </li>
        <li>
          <a href="javascript:;" class="crumb-home z-font-size-14">免费产品</a>
        </li>
        <li>
          <a href="javascript:;" class="z-font-size-14">免备案服务</a>
        </li>
      </ol>
    </div>
    <div class="page-main z-padding-h-20-precent">
      <div class="panel-heading">
        <div class="th-panel-title">免备案服务</div>
      </div>
      <div class="alert-master z-margin-top-5-precent z-margin-bottom-5-precent">
        <p>1：针对国内网站必须备案才可访问的问题，三丰云推出了独创的免备案服务，您的域名可以暂时不备案，直接使用。</p>
        <p>2：由于该服务采用的是海外线路，在访问速度和稳定性上比起国内线路还是要差一些，建议您把域名备案后使用国内线路。</p>
      </div>
      <div class="panel-body clearfix">
        <div class="ub-box z-margin-bottom-20-precent z-margin-top-5-precent">
          <el-button type="primary" size="mini" icon="el-icon-plus" @click="dialogSubmit = true">提交免备案域名</el-button>
          <div class="zj-select" style="margin-left: 25px">
            <el-input placeholder="关键词" v-model="search" class="input-with-select" @keyup.enter.native="SearchBmd">
              <el-select v-model="key_type" slot="prepend" placeholder="全部">
                <el-option label="域名" value="domainname"></el-option>
                <el-option label="IP" value="ip"></el-option>
              </el-select>
              <el-button slot="append" icon="el-icon-search" @click="SearchBmd"></el-button>
            </el-input>
          </div>
        </div>
        <div class="clearfix">
          <el-table :data="bmdList" highlight-current-row tooltip-effect="light" v-loading="listLoading" style="width: 100%;">
            <el-table-column prop="ptype" label="业务类型" align="left">
            </el-table-column>
            <el-table-column prop="domainname" label="域名" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="cname" label="别名地址" :render-header="renderHeader" align="center">
            </el-table-column>
            <el-table-column prop="ftp_user" label="ftp账号" align="center">
            </el-table-column>
            <el-table-column prop="ip" label="IP地址" align="center">
            </el-table-column>
            <el-table-column prop="setdate" label="提交日期" align="center">
            </el-table-column>
            <el-table-column prop="caozuo" label="操作" align="center">
              <template slot-scope="scope">
                <span class="z-curPonit z-color-red" @click="BmdDel(scope.row.type,scope.row.id)">删除</span>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination background layout="total, sizes" :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChange" :page-size="20" :total="total" class="pull-left" style="margin-bottom: 20px;">
          </el-pagination>
          <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="count" :total="total"
                         style="margin-bottom: 20px;">
          </el-pagination>
        </div>
        <div class="freevhost-help">
          <div class="se-panel-title ub-box">
            相关帮助：
          </div>
          <el-row :gutter="120">
            <el-col :span="12" v-for="(item,index) in gonggaoList" :key="item.id" v-if="item.title && index<2">
              <div class="notice-list-panel ub-box">
                <ul class="z-width-100-precent">
                  <li class="ub-box ub-between">
                <span class="notice-content z-oneline-overflow-hidden">
                  <span class="list-decoration-point">•</span>
                  <a :href="'/help/content_'+ item.id +'.html'" :title="item.title" target="_blank">{{item.title}}</a>
                </span>
                    <span class="z-color-999">
                  {{item.setdate.split(' ')[0]}}
								</span>
                  </li>
                </ul>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="120">
            <el-col :span="12" v-for="(item,index) in gonggaoList" :key="item.id" v-if="item.title && index>1 && index<4">
              <div class="notice-list-panel ub-box">
                <ul class="z-width-100-precent">
                  <li class="ub-box ub-between">
                <span class="notice-content z-oneline-overflow-hidden">
                  <span class="list-decoration-point">•</span>
                  <a :href="'/help/content_'+ item.id +'.html'" :title="item.title" target="_blank">{{item.title}}</a>
                </span>
                    <span class="z-color-999">
                  {{item.setdate.split(' ')[0]}}
								</span>
                  </li>
                </ul>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="120">
            <el-col :span="12" v-for="(item,index) in gonggaoList" :key="item.id" v-if="item.title && index>3 && index<6">
              <div class="notice-list-panel ub-box">
                <ul class="z-width-100-precent">
                  <li class="ub-box ub-between">
                <span class="notice-content z-oneline-overflow-hidden">
                  <span class="list-decoration-point">•</span>
                  <a :href="'/help/content_'+ item.id +'.html'" :title="item.title" target="_blank">{{item.title}}</a>
                </span>
                    <span class="z-color-999">
                  {{item.setdate.split(' ')[0]}}
								</span>
                  </li>
                </ul>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="120">
            <el-col :span="12" v-for="(item,index) in gonggaoList" :key="item.id" v-if="item.title && index>5 && index<8">
              <div class="notice-list-panel ub-box">
                <ul class="z-width-100-precent">
                  <li class="ub-box ub-between">
                <span class="notice-content z-oneline-overflow-hidden">
                  <span class="list-decoration-point">•</span>
                  <a :href="'/help/content_'+ item.id +'.html'" :title="item.title" target="_blank">{{item.title}}</a>
                </span>
                    <span class="z-color-999">
                  {{item.setdate.split(' ')[0]}}
								</span>
                  </li>
                </ul>
              </div>
            </el-col>
          </el-row>
        </div>
        <el-dialog title="提交免备案域名" :lock-scroll="false" :visible.sync="dialogSubmit" width="660px">
          <div v-if="vhost.length>0 || vps.length>0" class="ub-box ub-col z-margin-bottom-20-precent">
            <div class="ub-box ub-row">
              <p class="z-margin-left-50-precent z-margin-bottom-10-precent">
                <a style="color:red;" target="_blank" href="https://www.sanfengyun.com/help/content_1279.html">
                  关于免备案服务只有北京机房支持的说明
                </a>
              </p>
            </div>
            <div class="ub-box ub-row">
              <div class="z-margin-left-50-precent z-lineHeight-45">
                <el-select v-model="value" placeholder="请选择" class="z-margin-right-5-precent" style="width: 112px;">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="ub-box ub-col z-lineHeight-45">
                <el-select v-model="value2" placeholder="请选择业务" style="width: 350px;">
                  <el-option
                    v-for="item in list"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                <el-input v-model="input" placeholder="请输入域名" style="width: 350px;"></el-input>
                <p>*提交后系统将自动给出CNAME解析地址，按照此地址解析域名即可</p>
                <el-button type="primary" @click="submit" style="width: 58px;">提交</el-button>
              </div>
            </div>
          </div>
          <div v-if="vhost.length==0 && vps.length==0" class="z-textAlign-center z-margin-top-10-precent z-margin-bottom-20-precent">
            <p class="z-font-size-15 z-lineHeight-35">您还没有开通虚拟主机或云服务器，无法使用免备案服务。</p>
            <p><router-link to="/product" class="z-color-a z-font-size-15 z-lineHeight-35">点击这里开通免费虚拟主机</router-link></p>
            <p><router-link to="/freeServerList" class="z-color-a z-font-size-15 z-lineHeight-35">点击这里开通免费云服务器</router-link></p>
          </div>
        </el-dialog>
        <xdialog-loading :dialogLoading="dialogLoading"></xdialog-loading>
        <!--blackpink-->
        <div v-if="dialogShadow" class="dialogShadow"></div>
        <dl v-if="dialogShadow" class="dialogBody ub-box ub-col">
          <dd class="dialogTitle z-font-size-16">
            <span class="z-font-size-18 z-padding-left-10-precent">提示信息</span>
            <a class="aui_close" href="javascript:;" @click="clickBtn()">×</a>
          </dd>
          <dd class="dialogContent z-color-666 z-font-size-15 ">
            <img style="margin-left: 30px;margin-right: 30px;vertical-align: middle" src="../../assets/imgs/uc_warn.png" alt="">
            <span class="z-font-size-15" >免费主机仅限绑定在三丰云注册的域名</span>
            <br>
            <a href="/domain" target="_blank" class="z-color-a z-font-size-15" style="display: inline-block;margin-left: 157px">点击这里注册域名</a>
          </dd>
          <div class="dialogFooter ub-f1 ub-box ub-ver z-padding-v-15-precent">
            <!--<dd class="confirmBtn z-relative z-color-fff z-curPonit" @click="clickBtn(true)" style="background:#2ebace;">确认</dd>
            <dd class="confirmBtn z-relative z-color-fff z-curPonit" @click="clickBtn(false)" style="">取消</dd>-->
          </div>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
  import XdialogLoading from 'components/commons/XdialogLoading.vue'
  import beianService from 'business/beianService.js'
  import helpService from 'business/helpService.js'
  import { MessageBox } from 'element-ui';
    export default {
      data () {
        return {
          dialogSubmit:false,
          dialogShadow:false,
          dialogLoading:false,
          listLoading:false,
          gonggaoList: [],
          options: [{
            value: 'vhost',
            label: '虚拟主机'
          }, {
            value: 'vps',
            label: '云服务器'
          }],
          list: [],
          vhost:[],
          vps:[],
          value: 'vhost',
          value2: '',
          input:'',
          bmdList:[],
          search:'',
          key_type:'domainname',
          count:20,
          total:0,
          page:1,
        }
      },
      components:{
        XdialogLoading
      },
      props:{
        hide:Boolean
      },
      watch:{
        value(val){
          if(val === 'vhost'){
            this.list = this.vhost
            this.value2 = this.list[0].value
          }
          if(val === 'vps'){
            this.list = this.vps
            this.value2 = this.list[0].value
          }
        },
      },
      mounted() {
        this.getGonggao()
        this.getList()
        this.SearchBmd()
      },
      methods:{
        async getGonggao() {
          let {vueData, state} = await helpService.transformToVue('helpInfo','POST','cmd=query&type_id=267')
          if(vueData.response==200){
            this.gonggaoList = vueData.msg.content
          }else {
            this.$toast({tip:'请刷新页面...',type:'3'})
          }
        },
        async getList() {
          let {vueData, state} = await beianService.transformToVue('beianMain','POST','cmd=all_vhost_vps')
          if(state.code === '000'){
            this.vhost = vueData.vhost ? vueData.vhost.map((item, index) => {
              return {
                value:item.id,
                label:'FTP账号：ftp'+item.id
              }
            }) : []
            this.vps = vueData.vps ? vueData.vps.map((item, index) => {
              return {
                value:item.ip,
                label:'IP：'+item.ip
              }
            }) : []

            this.list = this.vhost ? this.vhost : this.vps
            this.value = this.vhost ? 'vhost' : 'vps'
            this.value2 = this.list[0] ? this.list[0].value : ''
          }else {
            this.$toast({tip:'请刷新页面...',type:'3'})
          }
        },
        async submit() {
          let data = 'cmd=domain_add'+
            '&domain_type='+ this.value +
            '&id_ip='+ this.value2 +
            '&domainname='+ this.input
          this.dialogLoading = true
          let {vueData, state} = await beianService.transformToVue('beianMain','POST',data)
          if(vueData.response == 200 ) {
            this.dialogLoading = false
            this.dialogSubmit = false
            let self = this
            this.$dialog({type:'success', info: vueData.msg, click () {self.SearchBmd()}})
          }else {
            this.dialogLoading = false
            if(vueData.msg === 'freehost_domain'){
              this.dialogShadow = true
            }else {
              this.$dialog({type:'error', info: vueData.msg, click () {}})
            }
          }
        },
        async SearchBmd() {
          this.listLoading = true
          let data = 'cmd=domain_list&keyword='+this.search + '&count=' + this.count + '&page='+ this.page
          let {vueData, state} = await beianService.transformToVue('beianMain','POST',data)
          if(vueData.response == 200 ) {
            this.total = vueData.msg.allcount
            this.bmdList = vueData.msg.content.map((item, index) => {
              return {
                ptype:item.ptype_info,
                domainname:item.domainname,
                cname:item.cname,
                ftp_user:item.ftp_user,
                ip:item.ip,
                setdate:item.setdate,
                id:item.id,
                type:item.ptype
              }
            })
            this.listLoading = false
          }else {
            this.$toast(vueData.msg,'fail')
          }
        },
        BmdDel(type,id) {
          MessageBox.confirm('您确定删除域名么?', '确认', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            lockScroll: false,
            type: 'warning'
          }).then(async() => {
            let data = 'cmd=domain_del'+
              '&domain_type=' + type +
              '&del_id=' + id
            this.dialogLoading = true
            let {vueData, state} = await beianService.transformToVue('beianMain','POST',data)
            if(vueData.response == 200 ) {
              this.dialogLoading = false
              let self = this
              this.$dialog({type:'success', info: vueData.msg, click () {self.SearchBmd()}})
            }else {
              this.dialogLoading = false
              this.$dialog({type:'error', info: vueData.msg, click () {}})
            }
          }).catch(() => {

          })
        },
        handleCurrentChange(val) {
          this.page = val;
          this.SearchBmd()
        },
        handleSizeChange(val) {
          this.count = val
          this.SearchBmd()
        },
        renderHeader(h, { column }) {
          return h(
            'span',
            [
              column.label,
              h(
                'a',
                {
                  attrs: {
                    'href': '/help/content_1110.html',
                    'class': 'dialog-help-link',
                    'target': '_blank'
                  }
                }
              )
            ]
          );
        },
        clickBtn() {
          this.dialogShadow = false
        }
      }
    }
</script>

<style scoped>
  .hideleft { margin-left: 80px; }
  .input-with-select .el-input-group__prepend .el-select {
    width: 90px;
  }
  .freevhost-help {
    margin-top: 20px;
    padding: 15px;
    border: 1px solid #eee;
    margin-bottom: 20px;
  }
  .notice-list-panel {
    padding: 5px 18px;
  }
  .notice-list-panel li:first-child {
    border-top: none;
  }
  .notice-list-panel li {
    line-height: 3.3rem;
    border-top: 1px dashed #eee;
  }

  .dialogShadow{position:fixed;z-index:9900;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.5);}
  .dialogBody{position:fixed;z-index:9909;top:37%;left:50%;transform:translateX(-50%);min-width:32rem;background:#fff;box-shadow: 0 0 10px 3px rgba(0,0,0,.2);animation:dialogAnimStart .2s forwards}
  .dialogTitle{position:relative;padding:1rem 0;background:#f7f9fa;color:#636566;}
  .dialogContent{padding: 2rem 2rem 2rem 0}
  .dialogFooter{background:#f7f9fa;}
  @keyframes dialogAnimEnd{
    from{opacity:1}
    to{opacity:0}
  }
  .aui_close {
    position: absolute;
    padding: 0;
    top: 31%;
    right: 22px;
    width: 21px;
    height: 21px;
    line-height: 21px;
    font-size: 30px;
    color: #636566;
    text-align: center;
    font-family: Helvetica, STHeiti;
  }
</style>



// WEBPACK FOOTER //
// src/pages/product/freeBeian.vue